import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";


function Page2() {
  useEffect(() => {
    document.title = "Маяк — Страница 1"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/" />
        <ForwardLink href="/page2" />
      </div>

      <p style={{ textAlign: "right" }}>1.</p>
      <p>ЧЕРНЫЙ ЭКРАН.</p>
      <p>Грохот одинокого ФОГОРНА. Низкий. Слабый.</p>
      <p><b>ЗАГОЛОВОК: THE LIGHTHOUSE</b></p>
      <br/>
      <p>СНАРУЖИ. АТЛАНТИЧЕСКИЙ ОКЕАН – ДЕНЬ</p>
      <p>
        ЧРЕЗВЫЧАЙНО ШИРОКИЙ ПЛАН: Туман. Больше ничего не видно. Медленно<br/>
        появляется МАЛЕНЬКАЯ ПАРОВАЯ ЛОДКА: МАЯЧНЫЙ ТЕНДЕР. Она пыхтит,<br/>
        крошечная точка в огромном океане. Клубы черного дыма выходят<br/>
        из кривого дымохода. Старый двигатель тихо урчит.
      </p>
      <br/>
      <p>Задержка.</p>
      <p>Снова ФОГОРН, теперь громче. Ближе.</p>
      <br/>
      <p>СНАРУЖИ. МАЯЧНЫЙ ТЕНДЕР. ЧЕЛН – ПОЗЖЕ</p>
      <p>
        БЛИЗКО: Гнилой, ржавый нос рассекает волны.<br/>
        Посредственный мотор урчит.
      </p>
      <p>Задержка.</p>
      <br/>
      <p>СНАРУЖИ. МАЯЧНЫЙ ТЕНДЕР. ПАЛУБА – ЗАКАТ</p>
      <p>
        ШИРОКИЙ ПЛАН: ТЕНИ стоят на носу лодки (спиной к КАМЕРЕ).<br/>
        Они могут быть и людьми, но с такой же легкостью могут быть и призраками.
      </p>
      <p>ФОГОРН РЕВЕТ. Это достаточно близко, чтобы почувствовать.</p>
      <p>ВСПЫШКА СВЕТА пробивается сквозь туман, открывая...</p>
      <p>
        Силуэт мрачного каменного острова, не больше акра:<br/>
        КАМЕННЫЙ ОСТРОВ. Несколько ветхих хозяйственных построек цепляются<br/>
        за поверхность словно ракушки. На самой высокой точке острова<br/>
        стоит высокая, рушащаяся БАШНЯ <u>МАЯКА</u>.<br/>
        Вокруг визжит и каркает зловещая стая ЧАЕК.
      </p>
      <p>ФОГОРН ревет и снова вспыхивает СВЕТ.</p>
      <p>САМ ОСТРОВ, кажется, притягивает лодку и людей ближе.</p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ. БЕРЕГ – ЗАКАТ</p>
      <p>В тумане темно, даже с мигающим светом наверху.</p>
      <p>
        ТРАНСФЕРНАЯ ЛОДКА стоит на берегу. ДВА ПОМОЩНИКА<br/>
        передают провизию ДВУМ МУЖЧИНАМ в темной форме и кепках.<br/>
        Это непростая задача.
      </p>
      <p style={{ textAlign: "right" }}>1.</p>

      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/" />
        <ForwardLink href="/page2" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1707340667/the-lighthouse-script/ohvrwdjomotcbt1qsrvq.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page2;
